import { graphql } from "react-relay";

export const UpsertAnthropicIntegrationMutation = graphql`
  mutation UpsertAnthropicIntegrationMutation(
    $input: UpsertAnthropicIntegrationInput!
  ) {
    upsertAnthropicIntegration(input: $input) {
      anthropicIntegration {
        configured
        id
        orgId
        orgName
      }
      problems {
        __typename
        message
      }
    }
  }
`;
